import { AfterContentInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CheckType } from '../enums/check-type.enum';
import { BaseService } from '../services/base.service';
import { CheckService } from './check.service';
import { ButtonType } from '../enums/button-type.enum';

@Component({
  selector: 'app-check',
  templateUrl: './check.component.html',
  styleUrls: ['./check.component.scss'],
  providers: [NgbModalConfig, NgbModal]
})
export class CheckComponent implements OnInit, AfterContentInit, OnDestroy {

  @ViewChild('r', { static: true }) r;
  @ViewChild('d', { static: true }) d;
  @ViewChild('w', { static: true }) w;
  @ViewChild('c', { static: true }) c;
  @ViewChild('c2', { static: true }) c2;
  @ViewChild('mrc', { static: true }) mrc;
  @ViewChild('mrc2', { static: true }) mrc2;

  list: Array<ViewChild> = [];

  /** 可修改 */
  revisability = [CheckType.REVISABILITY, CheckType.DECLINATURE];
  /** 拒保 */
  declinature = [CheckType.DECLINATURE];
  /** 提示 */
  warning = [CheckType.WARNING];
  /** 使用者確認修改頁面,是:導回首頁 否:停留在原頁面進行修改 */
  confirm = [CheckType.CONFIRM];
  /** 使用者確認 [ 確定 / 返回修改 ] */
  confirm2 = [CheckType.CONFIRM2];
  /** 微型附約確認 [ 同意 / 不同意 ] */
  microRiderConfirm = [CheckType.MICRO_RIDER_CONFIRM];
  /** 微型附約確認 [ 同意 / 不同意 ] */
  microRoleConfirm = [CheckType.MICRO_ROLE_CONFIRM, CheckType.DECLINATURE];

  private unsubscribe = new Subject();

  modal;

  message;

  type: Array<CheckType> = [];

  view: ViewChild;

  size = 'md';

  callback: (result?: any) => void;

  constructor(
    config: NgbModalConfig,
    private modalService: NgbModal,
    private checkService: CheckService,
    private baseService: BaseService
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  ngOnInit(): void {
    this.checkService.open()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(config => {
        this.message = config.message;
        switch (config.type) {
          case CheckType.REVISABILITY:
            this.type = [...this.revisability];
            break;
          case CheckType.DECLINATURE:
            this.type = [...this.declinature];
            break;
          case CheckType.WARNING:
            this.type = [...this.warning];
            break;
          case CheckType.CONFIRM:
            this.type = [...this.confirm];
            break;
          case CheckType.CONFIRM2:
            this.type = [...this.confirm2];
            break;
          case CheckType.MICRO_RIDER_CONFIRM:
            this.type = [...this.microRiderConfirm];
            break;
          case CheckType.MICRO_ROLE_CONFIRM:
            this.type = [...this.microRoleConfirm];
            break;
        }
        this.view = this.list[this.type[0]];
        this.callback = config.callbcak;
        this.size = config.size;
        this.open();
      });
  }

  ngAfterContentInit() {
    this.list = [this.r, this.d, this.w, this.c, this.c2, this.mrc, this.mrc2];
  }

  correct() {
    this.modal.close();
    this.view = this.list[this.type[1]];
    const source = timer(500);
    source.subscribe(() => this.open());
  }

  href() {
    window.location.href = this.baseService.info.indexUrl;
  }

  operate( clickButton?: string ) {
    this.close();
    this.callback(clickButton);
  }

  open() {
    this.modal = this.modalService.open(this.view, { ariaLabelledBy: 'modal-basic-title', size: this.size });
    this.modal.result.then((result) => { });
  }

  close() {
    this.modal.close();
  };

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


  scrollToPosition():void {
    const firstErrorTop = $('.error').offset() ? $('.error').offset().top : null;
    if ($('header')[0]) {
      const headerHt = $('header')[0].offsetHeight;
      if (isNaN(firstErrorTop) || isNaN(headerHt)) {
        return;
      }

      $('body,html').animate(
        { scrollTop: firstErrorTop - headerHt }, 800
      );
    }
  }

  get buttonType(): typeof ButtonType {
    return ButtonType;
  }
}

export class CheckConfig implements ICheckConfig {
  title?= '請注意';
  type = CheckType.WARNING;
  message?= '';
  size?= 'md';
  callbcak?= () => { };
}

export interface ICheckConfig {
  title?: string;
  type: CheckType;
  message?: string;
  size?: string;
  callbcak?: (result?: any) => void;
}
